// extracted by mini-css-extract-plugin
export var statItem = "_ml-1";
export var statsRow = "_ml-0";